import { axios } from "utils";

import { ADMIN_POPUPS_URL as endpoint } from "consts";

import { Popup, PopupRequest, PopupResponse } from "models";

export const getAllPopups = async ({ signal }: { signal: AbortSignal }): Promise<PopupResponse[]> => axios.get(`${endpoint}`, { signal });

export const updatePopup = async (data: PopupRequest[]) => axios.put(`${endpoint}`, { data });

export const getPopup = async ({ id, signal }: { id: string; signal: AbortSignal }): Promise<Popup[]> => axios.get(`${endpoint}/${id}`, { signal });
